import { LanguageAvailable } from '@shared/services/language/models';

/**
 * Rounds a number and groups its digits the way the locale does.
 *
 * @example
 * formatAsWholeNumber(12345.67, 'fr-FR'); // "12 346", grouped with a narrow no-break space
 * formatAsWholeNumber(12345.67, 'es-ES'); // "12.346"
 */
export function formatAsWholeNumber(numberToFormat: number, locale: LanguageAvailable): string {
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(numberToFormat);
}
